import { browserDetect } from '../src/browser-detection';
import { lazyload } from '../src/lazyload';
import { header } from '../src/header';
import { navigation } from '../src/navigation';
import { inputLabels } from '../src/labels';
import { initAccordion } from '../src/accordion';
import { initCarousel } from '../src/carousel';
import { initDropdownMenu } from '../src/menu';
import { initSelect } from '../src/select';
import { initTabs } from '../src/tabs';
import { initTickers } from '../src/quantity-ticker';
import { initMarquee } from '../src/marquee';
import { initPlayers } from '../src/player';
import { initHoverImage } from '../src/hover-image';
import { initMatchHeight } from '../src/match-height';

import { gravityFormFilters } from '../src/gravity-forms/utils';
import { gravityFormInputLabels } from '../src/gravity-forms/labels';
import { gravityFormSelect } from '../src/gravity-forms/select';

import { initEcommsSelect } from '../src/ecomms/select';
import { initLightbox } from '../src/ecomms/lightbox';
import { cartUpdateQuantity } from '../src/ecomms/cart-update';
import { checkoutDeliveryToggle } from '../src/ecomms/checkout-address';
import { initCheckoutInputLabels } from '../src/ecomms/label';
import { hideAddToCart } from '../src/ecomms/hide-add-to-cart-button';

import { calculatorBoards } from '../src/calculator/calculator-boards';
import { calculatorDiningTable } from '../src/calculator/calculator-dining-table';
import { calculatorPlanter } from '../src/calculator/calculator-planter';
import { calculatorTrestleTable } from '../src/calculator/calculator-trestle-table';
import { calculatorCladding } from '../src/calculator/calculator-cladding';
import { initCalculatorSelect } from '../src/calculator/select';
import { initCalculatorInputLabels } from '../src/calculator/label';
import { initCalculatorInputs } from '../src/calculator/input';

import { initNewsletterForm } from "../src/newsletter/form.js";
import { initPaypalButtons } from "../src/paypal-buttons.js";

export default {
  init() {
    // JavaScript to be fired on all pages
    header();
    navigation();
    browserDetect();
    lazyload();
    inputLabels();
    initAccordion();
    initCarousel();
    initDropdownMenu();
    initHoverImage();
    initMarquee();
    initPlayers();
    initSelect();
    initTabs();
    initTickers();
    initMatchHeight();

  
    gravityFormFilters();

    gravityFormInputLabels();

    gravityFormSelect();

    initLightbox();
    initEcommsSelect();
    cartUpdateQuantity();
    checkoutDeliveryToggle();
    initCheckoutInputLabels();
    // hideAddToCart();

    calculatorBoards();
    calculatorDiningTable();
    calculatorPlanter();
    calculatorTrestleTable();
    calculatorCladding();
    initCalculatorSelect();
    initCalculatorInputLabels();
    initCalculatorInputs();

    initNewsletterForm();
    initPaypalButtons();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
